//import styles from "./FilterSidebarSplitView.module.css";
import React from "react";
//import { IoIosArrowDropleftCircle } from "react-icons/io";
import "./filter-side-view.css";

const FilterSideViewComponent = (props) => {
  const { children, title } = props;
  const _title = title ? title : "Filters";
  return (
    <>
      <div className="__fssv_container">
        <div className="fssv_header">
          <div className="fssv_title">{_title}</div>
        </div>
        <div className="fssv_content">{children}</div>
      </div>
      <style>{`
      .__fssv_container {
        display: flex;
        flex-direction: column;
        flex: 1;
        background-color: #d4e7e9;
      }

      .fssv_header {
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: row;
        background-color: #71afb4;
        height: 50px;
        padding: 1em;
      }

      .fssv_content {
        position: relative;
      }

      .fssv_title {
        color: white;
        font-size: 1.3em;
        font-weight: 300;
        user-select: none;
      }

      .fssv_collapse-icon {
       position: absolute;
       display: flex;
       align-items: center;
       justify-content: center;
       right: -10px;
       top: 10px;
       font-size: 20px;
       color: white;
       background-color: #71AFB3;
       border-radius: 99999px;
       height: 32px;
       width: 32px;
       cursor: pointer;
       box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
      }
    `}</style>
    </>
  );
};

export default FilterSideViewComponent;
